/**
 * Vista: Catálogo de Líneas Comerciales (ERP F1, B1 · D2/D3)
 * Patrón de 2 pestañas (utils/pestanasErp.js): «Consultar» (listado y filtros) y «Agregar / editar» (código, descripción,
 * vendible/inventariable, garantía, controles y atributos de la línea). Jorge depura las líneas: la baja es deleted_at y se puede restaurar.
 */

import lineaComercialService from '../../services/lineaComercial.service.js';
import catalogos from '../../services/erpCatalogos.service.js';
import permisos from '../../services/permissions.service.js';
import modal from '../../utils/modal.js';
import toast from '../../utils/toast.js';
import { esc, errMsg, estadoBadge, chipsControles, val, numOrNull, NOMBRE_CONTROL } from './erpUi.js';
import { permisosPantalla, pestanasHtml, Pestanas } from '../../utils/pestanasErp.js';

const CONTROLES = ['serie', 'motor', 'lote', 'caducidad', 'pedimento'];

export default {
  data: {
    lineas: [],
    atributos: [],
    editing: null,
    filters: { search: '', activo: 'true', eliminadas: false }
  },

  async render() {
    const pp = permisosPantalla('lineas_comerciales');
    const formulario = `
      <div class="card erp-form-card" id="lineaFormCard">
        <div class="card-header">
          <h2 class="card-title" id="lineaFormTitulo">Nueva línea</h2>
          <span class="text-muted" id="lineaFormNota">Jorge depura el catálogo: aquí se dan de alta y se editan.</span>
        </div>
        <form id="lineaForm" autocomplete="off">
          <div class="form-row">
            <div class="form-group">
              <label>Código *</label>
              <input type="text" id="lc_codigo" class="form-control" maxlength="10" required placeholder="Ej: DRONE" style="text-transform:uppercase;" />
              <small class="form-help">Hasta 10 letras mayúsculas o números. No se cambia después.</small>
            </div>
            <div class="form-group" style="grid-column: span 2;">
              <label>Descripción *</label>
              <input type="text" id="lc_descripcion" class="form-control" maxlength="100" required placeholder="Ej: DRONES Y ROBOTS" />
            </div>
            <div class="form-group">
              <label>Orden</label>
              <input type="number" id="lc_orden" class="form-control" min="0" max="9999" placeholder="0" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Garantía por omisión (meses)</label>
              <input type="number" id="lc_garantia" class="form-control" min="0" max="240" placeholder="Sin garantía por omisión" />
            </div>
            <div class="form-group" style="grid-column: span 2;">
              <label>Notas</label>
              <input type="text" id="lc_notas" class="form-control" maxlength="250" placeholder="Opcional" />
            </div>
            <div class="form-group" style="display:flex;flex-direction:column;gap:.5rem;justify-content:flex-end;">
              <label class="erp-check"><input type="checkbox" id="lc_vendible" checked /> Se vende</label>
              <label class="erp-check"><input type="checkbox" id="lc_inventariable" checked /> Lleva inventario</label>
            </div>
          </div>

          <div class="erp-seccion">
            <h4>Controles que exige la línea</h4>
            <p class="form-help">Lo que se captura por cada pieza o lote al recibir y vender. «Obligatorio» impide guardar sin el dato.</p>
            <table class="erp-tabla-mini">
              <thead><tr><th>Control</th><th>Aplica</th><th>Obligatorio</th><th>Notas</th></tr></thead>
              <tbody>
                ${CONTROLES.map((c) => `
                  <tr>
                    <td>${NOMBRE_CONTROL[c]}</td>
                    <td><input type="checkbox" id="ctl_${c}_aplica" data-control="${c}" class="ctl-aplica" /></td>
                    <td><input type="checkbox" id="ctl_${c}_oblig" /></td>
                    <td>${c === 'serie' ? '<label class="erp-check"><input type="checkbox" id="ctl_serie_interna" /> Permite serie interna (la pone AgroMX)</label>' : ''}
                        ${c === 'motor' ? '<span class="text-muted">En implementos es opcional (D3)</span>' : ''}</td>
                  </tr>`).join('')}
              </tbody>
            </table>
          </div>

          <div class="erp-seccion">
            <h4>Atributos descriptivos</h4>
            <p class="form-help">Datos que describen al producto (HP, color, capacidad…). «Por pieza» = cambia en cada unidad (color, año).</p>
            <table class="erp-tabla-mini">
              <thead><tr><th>Usa</th><th>Atributo</th><th>Tipo</th><th>Nivel</th><th>Obligatorio</th></tr></thead>
              <tbody id="lc_atributosBody"><tr><td colspan="5" class="text-muted">Cargando atributos…</td></tr></tbody>
            </table>
            ${permisos.canCreate('atributos') ? `
            <details style="margin-top:.75rem;">
              <summary class="text-muted" style="cursor:pointer;">➕ Crear un atributo nuevo</summary>
              <div class="form-row" style="margin-top:.5rem;">
                <div class="form-group"><label>Nombre</label><input type="text" id="at_nombre" class="form-control" maxlength="80" placeholder="Ej: Color" /></div>
                <div class="form-group"><label>Tipo</label>
                  <select id="at_tipo" class="form-control">
                    <option value="texto">Texto</option><option value="numero">Número</option><option value="lista">Lista de opciones</option>
                    <option value="booleano">Sí / No</option><option value="fecha">Fecha</option>
                  </select></div>
                <div class="form-group"><label>Unidad</label><input type="text" id="at_unidad" class="form-control" maxlength="20" placeholder="HP, L, m…" /></div>
                <div class="form-group"><label>Opciones (si es lista)</label><input type="text" id="at_opciones" class="form-control" placeholder="Rojo, Azul, Verde" /></div>
                <div class="form-group" style="display:flex;align-items:flex-end;"><button type="button" class="btn btn-secondary" id="btnCrearAtributo">Crear atributo</button></div>
              </div>
            </details>` : ''}
          </div>

          <div class="erp-acciones-form">
            <button type="button" class="btn btn-secondary" id="btnLimpiarForm">Cancelar</button>
            <button type="submit" class="btn btn-primary" id="btnGuardarLinea">Guardar línea</button>
          </div>
        </form>
      </div>`;

    const consultar = `
      <div class="filters-card">
        <div class="filters-grid">
          <div class="form-group">
            <label>Buscar</label>
            <input type="text" id="searchInput" placeholder="Código o descripción..." class="form-control" />
          </div>
          <div class="form-group">
            <label>Estado</label>
            <select id="activoFilter" class="form-control">
              <option value="all">Todas</option>
              <option value="true" selected>Activas</option>
              <option value="false">Inactivas</option>
            </select>
          </div>
          <div class="form-group" style="display:flex;align-items:flex-end;">
            <label class="erp-check"><input type="checkbox" id="eliminadasFilter" /> Ver dadas de baja</label>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descripción</th>
                <th class="tbl-hide-mobile">Controles</th>
                <th class="tbl-hide-mobile">Atributos</th>
                <th class="tbl-hide-mobile">Venta / inventario</th>
                <th class="tbl-hide-mobile">Productos</th>
                <th>Estado</th>
                <th style="text-align:right;">Acciones</th>
              </tr>
            </thead>
            <tbody id="lineasTableBody">
              <tr><td colspan="8" class="text-center"><div class="loading-spinner"></div><p>Cargando líneas...</p></td></tr>
            </tbody>
          </table>
        </div>
      </div>
    `;
    return pestanasHtml({ id: 'lc', titulo: 'Líneas comerciales', ...pp, consultar, formulario });
  },

  async afterRender() {
    if (!permisos.canView('lineas_comerciales')) {
      document.getElementById('content').innerHTML = '<div style="padding:2rem;text-align:center;"><h2>Acceso denegado</h2></div>';
      return;
    }
    window.currentView = this;
    this.data.editing = null;
    this.tabs = new Pestanas('lc', { alAgregar: () => this.limpiarForm() });
    this.setupListeners();
    await Promise.all([this.cargarAtributos(), this.cargar()]);
  },

  setupListeners() {
    document.getElementById('lineaForm')?.addEventListener('submit', (e) => { e.preventDefault(); this.guardar(); });
    document.getElementById('btnLimpiarForm')?.addEventListener('click', () => { this.limpiarForm(); this.tabs.volver(); });
    document.getElementById('btnCrearAtributo')?.addEventListener('click', () => this.crearAtributo());
    document.querySelectorAll('.ctl-aplica').forEach((el) => el.addEventListener('change', () => {
      const c = el.dataset.control;
      const ob = document.getElementById(`ctl_${c}_oblig`);
      if (el.checked && ob && !ob.dataset.tocado) ob.checked = c !== 'motor';
      if (!el.checked && ob) ob.checked = false;
    }));
    CONTROLES.forEach((c) => document.getElementById(`ctl_${c}_oblig`)?.addEventListener('change', (e) => {
      e.target.dataset.tocado = '1';
      if (e.target.checked) document.getElementById(`ctl_${c}_aplica`).checked = true;
    }));
    let t;
    document.getElementById('searchInput')?.addEventListener('input', (e) => {
      clearTimeout(t);
      t = setTimeout(() => { this.data.filters.search = e.target.value; this.cargar(); }, 300);
    });
    document.getElementById('activoFilter')?.addEventListener('change', (e) => { this.data.filters.activo = e.target.value; this.cargar(); });
    document.getElementById('eliminadasFilter')?.addEventListener('change', (e) => { this.data.filters.eliminadas = e.target.checked; this.cargar(); });
  },

  async cargarAtributos(marcarIds = null) {
    try {
      const res = await catalogos.atributos.listar({ activo: 'true' });
      this.data.atributos = res?.data?.atributos || [];
    } catch (err) {
      this.data.atributos = [];
    }
    this.renderAtributos(marcarIds);
  },

  renderAtributos(seleccion = null) {
    const body = document.getElementById('lc_atributosBody');
    if (!body) return;
    const sel = new Map((seleccion || []).map((a) => [Number(a.atributo_id), a]));
    if (!this.data.atributos.length) {
      body.innerHTML = '<tr><td colspan="5" class="text-muted">Todavía no hay atributos.</td></tr>';
      return;
    }
    const TIPOS = { texto: 'Texto', numero: 'Número', lista: 'Lista', booleano: 'Sí/No', fecha: 'Fecha' };
    body.innerHTML = this.data.atributos.map((a) => {
      const s = sel.get(Number(a.id));
      return `
        <tr>
          <td><input type="checkbox" class="atr-usa" data-id="${a.id}" ${s ? 'checked' : ''} /></td>
          <td><strong>${esc(a.nombre)}</strong>${a.unidad ? ` <span class="text-muted">(${esc(a.unidad)})</span>` : ''}</td>
          <td class="text-muted">${TIPOS[a.tipo_dato] || esc(a.tipo_dato)}</td>
          <td><select class="form-control atr-nivel" data-id="${a.id}" style="padding:.15rem .3rem;font-size:.8rem;">
                <option value="producto" ${!s || s.nivel === 'producto' ? 'selected' : ''}>Por producto</option>
                <option value="unidad" ${s && s.nivel === 'unidad' ? 'selected' : ''}>Por pieza</option>
              </select></td>
          <td><input type="checkbox" class="atr-oblig" data-id="${a.id}" ${s && s.obligatorio ? 'checked' : ''} /></td>
        </tr>`;
    }).join('');
  },

  async crearAtributo() {
    const nombre = val('at_nombre');
    const tipo = val('at_tipo');
    if (!nombre) { toast.warning('Escribe el nombre del atributo'); return; }
    const body = { nombre, tipo_dato: tipo, unidad: val('at_unidad') || null };
    if (tipo === 'lista') body.opciones = (val('at_opciones') || '').split(',').map((s) => s.trim()).filter(Boolean);
    try {
      const res = await catalogos.atributos.crear(body);
      toast.success(`Atributo ${res.data?.nombre || nombre} creado`);
      const actuales = this.leerAtributos();
      actuales.push({ atributo_id: res.data.id, nivel: 'producto', obligatorio: false });
      ['at_nombre', 'at_unidad', 'at_opciones'].forEach((id) => { const el = document.getElementById(id); if (el) el.value = ''; });
      await this.cargarAtributos(actuales);
    } catch (err) {
      toast.error(errMsg(err, 'No se pudo crear el atributo'));
    }
  },

  leerControles() {
    return CONTROLES.filter((c) => document.getElementById(`ctl_${c}_aplica`)?.checked).map((c) => ({
      control: c,
      obligatorio: !!document.getElementById(`ctl_${c}_oblig`)?.checked,
      permite_serie_interna: c === 'serie' ? !!document.getElementById('ctl_serie_interna')?.checked : false
    }));
  },

  leerAtributos() {
    return [...document.querySelectorAll('.atr-usa')].filter((el) => el.checked).map((el, i) => {
      const id = Number(el.dataset.id);
      return {
        atributo_id: id,
        nivel: document.querySelector(`.atr-nivel[data-id="${id}"]`)?.value || 'producto',
        obligatorio: !!document.querySelector(`.atr-oblig[data-id="${id}"]`)?.checked,
        orden: (i + 1) * 10
      };
    });
  },

  limpiarForm() {
    this.data.editing = null;
    document.getElementById('lineaForm')?.reset();
    const cod = document.getElementById('lc_codigo');
    if (cod) cod.readOnly = false;
    CONTROLES.forEach((c) => { const o = document.getElementById(`ctl_${c}_oblig`); if (o) delete o.dataset.tocado; });
    document.getElementById('lineaFormTitulo').textContent = 'Nueva línea';
    document.getElementById('lineaFormCard')?.classList.remove('editando');
    document.getElementById('btnGuardarLinea').textContent = 'Guardar línea';
    this.renderAtributos([]);
  },

  async editar(codigo) {
    try {
      const res = await lineaComercialService.obtener(codigo);
      const l = res?.data;
      this.data.editing = l;
      document.getElementById('lineaFormTitulo').textContent = `Editar línea ${l.codigo}`;
      document.getElementById('lineaFormCard')?.classList.add('editando');
      document.getElementById('btnGuardarLinea').textContent = 'Guardar cambios';
      const cod = document.getElementById('lc_codigo');
      cod.value = l.codigo;
      cod.readOnly = true;
      document.getElementById('lc_descripcion').value = l.descripcion || '';
      document.getElementById('lc_orden').value = l.orden ?? '';
      document.getElementById('lc_garantia').value = l.garantia_meses_default ?? '';
      document.getElementById('lc_notas').value = l.notas || '';
      document.getElementById('lc_vendible').checked = !!l.vendible;
      document.getElementById('lc_inventariable').checked = !!l.inventariable;
      for (const c of l.controles || []) {
        document.getElementById(`ctl_${c.control}_aplica`).checked = !!c.aplica;
        const ob = document.getElementById(`ctl_${c.control}_oblig`);
        ob.checked = !!c.obligatorio;
        ob.dataset.tocado = '1';
        if (c.control === 'serie') document.getElementById('ctl_serie_interna').checked = !!c.permite_serie_interna;
      }
      this.renderAtributos(l.atributos || []);
      this.tabs.abrirFormulario({ editando: true, etiqueta: l.codigo });
    } catch (err) {
      toast.error(errMsg(err, 'No se pudo abrir la línea'));
    }
  },

  async guardar() {
    const codigo = (val('lc_codigo') || '').toUpperCase();
    const descripcion = val('lc_descripcion');
    if (!codigo || !descripcion) { toast.warning('Código y descripción son obligatorios'); return; }
    if (!/^[A-Z0-9]+$/.test(codigo)) { toast.warning('El código solo puede tener letras mayúsculas y números'); return; }
    const body = {
      descripcion: descripcion.toUpperCase(),
      vendible: val('lc_vendible'),
      inventariable: val('lc_inventariable'),
      garantia_meses_default: numOrNull(val('lc_garantia')),
      notas: val('lc_notas') || null,
      controles: this.leerControles(),
      atributos: this.leerAtributos()
    };
    const orden = numOrNull(val('lc_orden'));
    if (orden !== null) body.orden = orden;
    try {
      if (this.data.editing) {
        await lineaComercialService.actualizar(this.data.editing.codigo, body);
        toast.success(`Línea ${codigo} actualizada`);
      } else {
        await lineaComercialService.crear({ codigo, ...body });
        toast.success(`Línea ${codigo} creada`);
      }
      this.limpiarForm();
      this.tabs.volver();
      await this.cargar();
    } catch (err) {
      toast.error(errMsg(err));
    }
  },

  async cargar() {
    const tbody = document.getElementById('lineasTableBody');
    try {
      const params = { activo: this.data.filters.activo || 'all' };
      if (this.data.filters.search) params.search = this.data.filters.search;
      if (this.data.filters.eliminadas) params.incluir_eliminadas = true;
      const res = await lineaComercialService.listar(params);
      this.data.lineas = res?.data?.lineas || [];
      this.renderTabla();
    } catch (err) {
      tbody.innerHTML = `<tr><td colspan="8" class="text-center" style="color:var(--danger);padding:2rem;">${esc(errMsg(err, 'Error al cargar'))}</td></tr>`;
    }
  },

  renderTabla() {
    const tbody = document.getElementById('lineasTableBody');
    if (!tbody) return;
    if (!this.data.lineas.length) {
      tbody.innerHTML = '<tr><td colspan="8" class="text-center" style="padding:2rem;color:var(--gray-500);">Sin registros.</td></tr>';
      return;
    }
    tbody.innerHTML = this.data.lineas.map((l) => `
      <tr ${!l.activo || l.deleted_at ? 'style="opacity:0.6;"' : ''}>
        <td><code>${esc(l.codigo)}</code></td>
        <td>${esc(l.descripcion)}${l.notas ? `<div class="text-muted" style="font-size:.75rem;">${esc(l.notas)}</div>` : ''}</td>
        <td class="tbl-hide-mobile">${chipsControles(l.controles)}</td>
        <td class="tbl-hide-mobile" style="font-size:.8rem;">${l.atributos ? esc(l.atributos) : '<span class="text-muted">—</span>'}</td>
        <td class="tbl-hide-mobile" style="font-size:.8rem;">${l.vendible ? 'Se vende' : '<strong>No se vende</strong>'} · ${l.inventariable ? 'inventario' : '<strong>sin inventario</strong>'}${l.garantia_meses_default != null ? ` · ${l.garantia_meses_default} m` : ''}</td>
        <td class="tbl-hide-mobile">${l.productos || 0}</td>
        <td>${estadoBadge(l, { activo: 'Activa', inactivo: 'Inactiva' })}</td>
        <td style="text-align:right;white-space:nowrap;">
          ${l.deleted_at ? (permisos.canDelete('lineas_comerciales') ? `<button class="btn-icon btn-success" title="Restaurar" onclick="window.currentView.restaurar('${esc(l.codigo)}')">↩️</button>` : '') : `
            ${permisos.canEdit('lineas_comerciales') ? `<button class="btn-icon btn-edit" title="Editar" onclick="window.currentView.editar('${esc(l.codigo)}')">✏️</button>` : ''}
            ${permisos.can('lineas_comerciales', 'cambiar_estado') ? `<button class="btn-icon ${l.activo ? 'btn-warning' : 'btn-success'}" title="${l.activo ? 'Desactivar' : 'Activar'}" onclick="window.currentView.${l.activo ? 'desactivar' : 'reactivar'}('${esc(l.codigo)}')">${l.activo ? '⏸️' : '▶️'}</button>` : ''}
            ${permisos.canDelete('lineas_comerciales') ? `<button class="btn-icon btn-danger" title="Dar de baja" onclick="window.currentView.eliminar('${esc(l.codigo)}')">🗑️</button>` : ''}`}
        </td>
      </tr>
    `).join('');
  },

  titulo(codigo) {
    const l = this.data.lineas.find((x) => x.codigo === codigo);
    return l ? `${esc(l.codigo)} — ${esc(l.descripcion)}` : esc(codigo);
  },

  desactivar(codigo) {
    modal.confirm('Desactivar línea', `<p>¿Desactivar <strong>${this.titulo(codigo)}</strong>? No se podrán dar de alta productos nuevos en ella.</p>`, async () => {
      try { await lineaComercialService.desactivar(codigo); toast.success('Línea desactivada'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
    });
  },

  reactivar(codigo) {
    modal.confirm('Reactivar línea', `<p>¿Reactivar <strong>${this.titulo(codigo)}</strong>?</p>`, async () => {
      try { await lineaComercialService.reactivar(codigo); toast.success('Línea reactivada'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
    });
  },

  eliminar(codigo) {
    modal.confirm('Dar de baja la línea', `<p>¿Dar de baja <strong>${this.titulo(codigo)}</strong>?</p><p class="text-muted">No se borra: sale de los listados y de los selects, y se puede restaurar con «Ver dadas de baja».</p>`, async () => {
      try { await lineaComercialService.eliminar(codigo); toast.success('Línea dada de baja'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
    });
  },

  async restaurar(codigo) {
    try { await lineaComercialService.restaurar(codigo); toast.success('Línea restaurada'); await this.cargar(); } catch (err) { toast.error(errMsg(err)); }
  }
};
